module.exports = __webpack_public_path__ + "static/img/6.fc1703e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/6.png
// module id = VM1M
// module chunks = 1